import { COLORS } from '@app/constants/STYLES';
import { Button, Modal } from 'antd';
import styled from 'styled-components';

// ========== ClosedBy BottomSheet 스타일 ==========
export const BottomSheetHeader = styled.div`
  padding: 16px 20px 12px;
  border-bottom: 1px solid #2a2c2e;
`;

export const BottomSheetTitle = styled.h3`
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
  margin: 0;
`;

export const BottomSheetBody = styled.div`
  padding: 16px 20px 24px;
`;

// ========== ClosedBy 모달 스타일 ==========
export const CustomModal = styled(Modal)`
  .ant-modal-close {
    width: 16px;
    height: 16px;
    top: 24px;
    right: 24px;
  }
`;

export const SummaryBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background-color: #2a2c2e;
  border-radius: 6px;
  height: 38px;
  padding: 4px 12px;
  margin-bottom: 16px;
`;

export const SummaryText = styled.span`
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: -0.28px;
  color: #ffffff;
`;

export const Dot = styled.span`
  width: 2px;
  height: 2px;
  border-radius: 50%;
  background-color: #ffffff;
`;

export const InfoList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 0;
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 12px;
  letter-spacing: -0.36px;
`;

export const Label = styled.span`
  color: #b3b5bd;
`;

export const Value = styled.span`
  color: #ffffff;
`;

export const CheckboxWrapper = styled.div`
  margin-top: 42px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const CheckboxLabel = styled.span`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 12px;
  letter-spacing: -0.36px;
  line-height: 1;
  position: relative;
  top: 1px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;
`;

export const CancelButton = styled.button`
  flex: 1;
  height: 38px;
  border-radius: 12px;
  border: 1px solid #353535;
  background-color: transparent;
  color: #ffffff;
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: -0.28px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #07d993;
  }
`;

export const ConfirmButton = styled.button<{ $bgColor: string }>`
  flex: 1;
  height: 38px;
  border-radius: 12px;
  border: none;
  background-color: ${({ $bgColor }) => $bgColor};
  color: #0d1117;
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: -0.28px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    transform: translateY(-1px);
    background-color: transparent;
    border: 1px solid #07d993;
    color: #fff;
  }
`;
// ========== Modal 스타일 끝 ==========

export const TradeDetailListSection = styled.div<{ type: string }>`
  height: 100%;
  width: ${({ type }) => (type === 'orders' ? '100%' : '100%')};
  max-width: ${({ type }) => (type === 'orders' ? '1200px' : '100%')};
  margin-top: ${({ type }) => (type === 'orders' ? '20px' : '0px')};
  overflow: hidden;
  padding-bottom: 60px;
  padding-inline: 3px;

  & .ant-card {
    // background: ${(props) => props.theme.COLORS.drawerBgColor} !important;
    background: transparent !important;
    border: 0;
    color: ${(props) => props.theme.COLORS.textw};
    border-radius: 0;
  }

  & .ant-table {
    border-radius: 0;
    // background: ${(props) => props.theme.COLORS.drawerBgColor} !important;
    background: transparent !important;
    color: ${(props) => props.theme.COLORS.textw};
    width: 100% !important;
    max-width: 100% !important;
    table-layout: fixed !important;
  }

  & .ant-table-container {
    border-start-start-radius: 0 !important;
    border-start-end-radius: 0 !important;
    background: transparent !important;
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: auto !important;
  }

  & .ant-table-header {
    border-radius: 0 !important;
    padding: 0;
    background: transparent !important;
    border-top: none !important;
    border-bottom: none !important; // 추가
  }

  & .ant-table-header::before {
    width: 0 !important;
  }

  & .ant-table-thead .ant-table-cell {
    border-radius: 0 !important;
    padding: 0;
    background: transparent !important;
    color: ${(props) => props.theme.COLORS.textw};
    border: none !important;
    border-bottom: 1px solid ${(props) => props.theme.COLORS.tableDivider} !important;
    box-shadow: none !important;
    font-size: 11px !important;
  }

  & .ant-table-column-sorters {
    justify-content: flex-start !important;
    gap: 0 !important;
    width: 100% !important;
    cursor: pointer !important;
  }

  & .ant-table-column-sorter {
    display: none !important;
  }

  & .ant-table-column-title {
    flex: 1 !important;
  }

  & .ant-table-header .ant-table-cell {
    border-radius: 0 !important;
    padding: 0;
    background: transparent !important;
    color: ${(props) => props.theme.COLORS.textw};
    border: 0;
    box-shadow: none !important;
  }

  & .ant-table-thead .ant-table-cell::before {
    width: 0 !important;
  }

  & .ant-table-header .ant-table-cell::before {
    width: 0 !important;
  }

  & .ant-table-body .ant-table-cell {
    //  background: ${(props) => props.theme.COLORS.drawerBgColor} !important;
    background: transparent !important;
    color: ${(props) => props.theme.COLORS.textw};
    border-bottom: 1px solid ${(props) => props.theme.COLORS.tableDivider} !important;
  }

  & .ant-table-row:hover .ant-table-cell {
    background: ${(props) => props.theme.COLORS.drawerBgColor} !important;
    color: ${(props) => props.theme.COLORS.textw};
  }

  & .ant-table-footer {
    background: ${(props) => props.theme.COLORS.drawerBgColor} !important;
    color: ${(props) => props.theme.COLORS.textw};
    border-radius: 0;
  }

  & .ant-pagination .ant-pagination-item a {
    background: ${(props) => props.theme.COLORS.drawerBgColor} !important;
    color: ${(props) => props.theme.COLORS.textw};
  }

  & .ant-pagination li button {
    background: ${(props) => props.theme.COLORS.drawerBgColor} !important;
    color: ${(props) => props.theme.COLORS.textw} !important;
  }
`;
export const TradeDetailListHeaderSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: center;
  color: ${COLORS.lightGray5};
`;

export const TradeDetailListItemSection = styled.div`
  width: 100%;
  align-items: center;
  justify-content: space-between;
  align-self: center;
  display: flex;
  flex-direction: row;

  margin-top: 10px;
`;

export const TradeText = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: flex-start;
  min-width: 50px;
  width: 100%;
  font-size: 13px;
  gap: 1px;
  line-height: 1.2;
  color: ${(props) => props.theme.COLORS.textw};
  @media (max-width: 900px) {
    font-size: 12px;
  }
  @media (max-width: 600px) {
    font-size: 10px;
  }
`;

export const LimitMarketButton = styled(Button)`
  background: transparent;
  white-space: nowrap;
  font-size: 12px;
  border: 1px solid rgb(53, 53, 53);
  border-radius: 4px;
  line-height: 1;
  height: 24px;
  color: rgb(179, 181, 189);
  font-family: NanumSquareRound, sans-serif;

  &:hover,
  &:focus {
    border: 1px solid rgb(102, 102, 104) !important;
    color: #fff !important;
    background: transparent !important;
  }
`;
